export const IconGrayBlock: {
  name: 'icon_gray_block-254ff956eb5a'
} = {
  name: 'icon_gray_block-254ff956eb5a'
}
